import { render, staticRenderFns } from "./Comp25t2.vue?vue&type=template&id=5402e0a5&scoped=true&"
import script from "./Comp25t2.vue?vue&type=script&lang=js&"
export * from "./Comp25t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp25t2.vue?vue&type=style&index=0&id=5402e0a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5402e0a5",
  null
  
)

export default component.exports